export default __webpack_public_path__ + "static/media/nasa_app_vanillaJS.af711929.PNG";